module.exports = __webpack_public_path__ + "img/logo_flow_simulation_game_by_AGILEA.9839fc95.png";